type TArgs = {
  method: string;
  url: string;
  data: Record<string, string>;
};

const submitDataAsForm = ({ method, url, data }: TArgs): void => {
  const form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", url);
  Object.entries(data).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.setAttribute("type", "hidden");
    input.setAttribute("name", name);
    input.setAttribute("value", value);
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
};
export default submitDataAsForm;
